import { z } from "zod";

export const select2FASchema = z.object({
  type: z.enum(["email", "totp", "sms"], {
    required_error: "You need to select a authentication method.",
  }),
});

export type Select2FAFormData = z.infer<typeof select2FASchema>;
